"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDuplicateLookupResponseFactory = exports.userDuplicateLookupResultFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const mocks_1 = require("../../../mocks");
exports.userDuplicateLookupResultFactory = Factory.Sync.makeFactory({
    confidence: 'low',
    created_at: mocks_1.dates.date2000,
    found_user_last_login: mocks_1.dates.date2000,
    found_user_obfuscated_email: 't**t@e*****e.com',
    found_user_uuid: uuid_1.v4(),
    id: Factory.each(i => i + 1),
    status: null,
    updated_at: mocks_1.dates.date2000,
    user_duplicate_lookup_id: Factory.each(i => i + 1),
});
exports.userDuplicateLookupResponseFactory = Factory.Sync.makeFactory({
    created_at: mocks_1.dates.date2000,
    date_of_birth: mocks_1.persona.date_of_birth,
    first_name: mocks_1.persona.first_name,
    email: mocks_1.persona.email,
    id: Factory.each(i => i + 1),
    last_name: mocks_1.persona.last_name,
    originator: 'account_create',
    phone: mocks_1.persona.phone,
    updated_at: mocks_1.dates.date2000,
    user_duplicate_lookup_results: exports.userDuplicateLookupResultFactory.buildList(2)
});
